import { applyFirebaseResponseStatusesSlice } from '@app/store/slices/announcement_responses'
import { setFirebaseOffers } from '@app/store/slices/firebase_offers'
import { applyFirebasePhonesSlice } from '@app/store/slices/users'
import { createThunk } from '@app/store/thunk'
import type { FirebaseBatch } from '@app/store/types/firebase'

/**
 * One buffered mutation window from the firebase database, fanned out to the slices that mirror
 * a part of it. Dispatched here rather than observed by each slice, so a slice module that has
 * not been evaluated yet cannot silently miss the batch.
 */
export const applyFirebaseBatch = (batch: FirebaseBatch) =>
  createThunk(dispatch => {
    dispatch(applyFirebasePhonesSlice(batch))
    dispatch(applyFirebaseResponseStatusesSlice(batch))
    dispatch(setFirebaseOffers(batch))
  })
